import { Box, Flex } from "@chakra-ui/react";
import { forwardRef } from "react";

export const ButtonWithIcon = forwardRef(
  ({ icon, label, disabled, mode, onClick, className }, ref) => {
    const revertOrder = mode === "create-post-button";
    const applyClassName = className || "loom-purple-button"
    
    return (
      <Box
        as="button"
        opacity={disabled ? 0.5 : 1}
        onClick={!disabled && onClick}
        ref={ref && ref}
        className={applyClassName}
      >
        {revertOrder ? (
          <Flex justify='center' align='center' gap='0.8em' >
            {icon && <Box as={icon} boxSize={['1em', "1.2em"]} color='brand.500'/>}
            <Box>{label}</Box>
          </Flex>
        ) : (
          <>
            <Box fontSize={['0.875em', '1em']}>{label}</Box>
            {icon && <Box as={icon} boxSize={['1em', "1.2em"]} color='brand.500'/>}
          </>
        )}
      </Box>
    );
  },
);
